export default {
  items: [
    {
      name: "連携定義",
      url: "/index",
      icon: "icon-drawer"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js